// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalQuestionBuilder_root__2r276"};